import {
  Menu,
  MenuList,
  MenuOptionGroup,
  MenuItemOption,
  Portal,
} from '@cdl/heartbeat-react';
import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { leadNamesSelector } from '../ecg/selectors/signal.selectors';
import * as layoutActions from '../layout/actions/layout.actions';
import { restingLeadSelector } from '../layout/selectors/layout.selectors';
import { inverseParseLeadName, parseLeadName } from '../plot/utils/lead';
import { MenuButtonWithTooltip } from '../../shared/components/MenuButtonWithTooltip';

export const LeadChange: React.FC = () => {
  const dispatch = useDispatch();
  const leads = useSelector(leadNamesSelector);
  const selectedLead = useSelector(restingLeadSelector);

  const onChangeLead = useCallback(
    (lead: string) => {
      dispatch(
        layoutActions.update({ update: { lead: inverseParseLeadName(lead) } }),
      );
    },
    [dispatch],
  );

  const parsedLeads = useMemo(
    () => leads.map((lead) => parseLeadName(lead)),
    [leads],
  );

  const parsedSelectedLead = useMemo(
    () => parseLeadName(selectedLead),
    [selectedLead],
  );

  return (
    <Menu>
      <MenuButtonWithTooltip
        tooltipLabel='Change Bottom Lead'
        data-testid='lead-dropdown'
        px='s'
      >
        {parsedSelectedLead}
      </MenuButtonWithTooltip>
      <Portal>
        <MenuList minWidth='unset'>
          <MenuOptionGroup
            type='radio'
            value={parsedSelectedLead}
            onChange={(lead) => onChangeLead(lead as string)}
          >
            {parsedLeads.map((lead) => (
              <MenuItemOption key={lead} value={lead}>
                {lead}
              </MenuItemOption>
            ))}
          </MenuOptionGroup>
        </MenuList>
      </Portal>
    </Menu>
  );
};
